type FetchOptions = RequestInit & { token?: string };

export const fetchJson = async <T,>(url: string, options: FetchOptions = {}): Promise<T> => {
  const { token, ...requestInit } = options;
  const response = await fetch(url, {
    ...requestInit,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(requestInit.headers ? (requestInit.headers as Record<string, string>) : {}),
    },
  });

  if (!response.ok) {
    const message = await response.text();
    const error = new Error(message || `Request failed with ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return (await response.json()) as T;
};

export const formatError = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'Unexpected error occurred';
};

